import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../../store';
import SliderListItem from '../../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../../store/extensions';
import { IMAGE_ELEMENT_SHADOW_SLIDER_MULTIPLIER } from '../../../../../CreatePageConstants';

const ImageElementShadowDistanceListItem = (props) => {
    const { shadowSettingsDistance, updateImageElement, index } = props;

    const onShadowDistanceChange = (value) => {
        previewHistoryBatch.start();
        updateImageElement(index, { shadowSettings: { distance: value } });
    };

    return (
        <SliderListItem
            title='Distance'
            value={shadowSettingsDistance}
            displayMultiplier={IMAGE_ELEMENT_SHADOW_SLIDER_MULTIPLIER}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowDistanceChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageElement = (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images)[ownProps.index];
    const shadowSettings = imageElement?.shadowSettings || {};
    return { shadowSettingsDistance: shadowSettings.distance };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementShadowDistanceListItem);
